define('components/decorators/pagination',[
    'jquery',
    '../util/reload-fragments',
    'components/decorator'
], function($, reload, decorator) {

    var FORM_ERROR_HEADER = 'form-errors';

    $.extend(companyInfo.decorators, {

        'pagination': function(e) {
            var component = $(this);
            var pageInput = component.find('[name="page"]');
            var nrOfPages = pageInput.data('nrofpages');
            var pageNumber = pageInput.val();
            var pageElements = component.find('a');
            var buttonplaceholder = component.find('[data-buttonplaceholder]');


            $(window).resize(showElements);



            //check how many elements can be on 1 row
            function showElements(e) {
              var paginationWidth = buttonplaceholder.width();
              //check the max of buttons that can be shown
              var maxElements = Math.floor(paginationWidth / 27);
              pageNumber = parseInt(pageNumber);

              //calculate the min and max value of the numbers
              var minNumb = pageNumber - Math.floor(maxElements/2);
              var maxNumb = pageNumber + Math.floor(maxElements/2);
              var extra;
              if(minNumb < 0 ){
                extra = 0 - minNumb;
                maxNumb += extra+1;
              }else if(maxNumb > nrOfPages){
                extra = maxNumb - nrOfPages;
                minNumb -= extra;
              }

              //pagination-count
              buttonplaceholder.find('a').each(function(){
                var numb = parseInt($(this).data("pagination-count"));

                if(numb > minNumb && numb < maxNumb){
                    $(this).show();
                }else{
                    $(this).hide();
                }
              });
            }


            pageElements.click(function (e) {
                $(e.currentTarget).hasClass('first');
                if ($(e.currentTarget).hasClass('first')) {
                    pageNumber = 1;
                } else if ($(e.currentTarget).hasClass('previous')) {
                    pageNumber --;
                } else if ($(e.currentTarget).hasClass('next')) {
                    pageNumber ++;
                } else if ($(e.currentTarget).hasClass('last')) {
                    pageNumber = nrOfPages;
                } else {
                    pageNumber = e.currentTarget.innerHTML;
                }
                pageInput.val(pageNumber);

                //check if there is a parent form. if so, this will handle the refresh (see filter forms)
                //else we need to get the url and add the page to it
                var parentForm = component.closest("form");
                if(parentForm.length){
                  pageInput.change();
                }else{
                  //renew the page param with the new number
                  var newURL = setPageParam(location, pageNumber);
                  reload( "follow", newURL, function(){
                      pageInput.val(pageNumber);
                  });
                }


                /**
                 * check if there is a page parameter in the url.
                 * if so, replace. if not add.
                 * and then return the url
                 */
                function setPageParam(location, pageNumb){
                  if(!location){return;}
                  var queryString = location.search.substr(1);
                  var newParams = [];
                  var hasPageNumb = false;
                  var params = queryString.split("&");

                  for(var i=0; i<params.length; i++){
                    var hash = params[i].split('=');
                    if(hash[0] === 'page'){
                      hash[1] = pageNumb;
                      hasPageNumb = true;
                    }
                    if(hash[0] !== undefined && hash[1] !== undefined){
                      newParams.push(hash[0]+'='+hash[1]);
                    }

                  }
                  if(!hasPageNumb){
                    newParams.push('page='+pageNumb);
                  }
                  var url = [location.pathname,newParams.join('&')].join('?');
                  return url;
                }
            });
          showElements();
        },

    });

});

